export const analyticConfig = {
  startBindcard: {
    cid: 'c_5keptfuy',
    bid: 'b_pay_c911lqcf_mc',
  },
  bindCardEntry: {
    mv: 'b_pay_fjw86oa9_mv',
    mc: 'b_pay_fjw86oa9_mc',
  },
  index: {
    cid: 'c_fi285vsq',
    bid: {
      availableAmountShow: 'b_pay_hlqsofmt_mv',
      jumpRechargeBtnShow: 'b_pay_b_24q19ccm_mv',
      jumpWithdrawBtnShow: 'b_pay_b_x2hi01f2_mv',
      jumpRechargeBtnClick: 'b_24q19ccm',
      jumpWithdrawBtnClick: 'b_x2hi01f2',
    },
  },
  recharge: {
    cid: 'c_shc250ps',
    bid: {
      onSubmit: 'b_5gkiqo59',
      success: 'b_pay_m2dmmxxv_mc',
      cashdeskError: 'b_pay_cashdesk_error_mc',
      cashdeskShow: 'b_pay_cashdesk_show_mc',
      updateBankShow: 'b_pay_updateBank_mc',
      rechargeAmount: 'b_pay_rechargeAmount_mc',
      inputProcessTime: 'b_pay_wocy36mr_mc',
      limitModalShow: 'b_pay_okvrqp77_mv',
      class1LimitModalShow: 'b_pay_kxcgwqz3_mv',
      class1LimitModalClick: 'b_pay_4zwnmyyk_mc',
      class2LimitModalShow: 'b_pay_627vp8ue_mv',
    },
    bo: {
      onSubmit: 'b_shc250ps_bo_2015051300000001',
    },
  },
  withdraw: {
    cid: 'c_2ydap1n',
    bid: {
      onSubmit: 'b_p3z6wkxm',
      success: 'b_pay_jvch639o_mc',
      limitTipShow: 'b_pay_p2palnso_mv',
      limitTipClick: 'b_pay_0d0l8yes_mc',
      class1LimitModalShow: 'b_pay_ujdehdja_mv',
      class1LimitModalClick: 'b_pay_s7mkujbo_mc',
      excessiveModalShow: 'b_pay_e0y6u5hk_mv',
      excessiveModalClick: 'b_pay_97q3f2bf_mc',
      balanceDisposalEntryShow: 'b_pay_o5v05m7m_mv',
      balanceDisposalEntryClick: 'b_pay_o5v05m7m_mc',
      realNameInfoShow: 'b_pay_jem1f7kd_mv',
      realNameInfoClick: 'b_pay_jem1f7kd_mc',
      notSelfModalShow: 'b_pay_vo7xv4eh_mv',
      notSelfBtnClick: 'b_pay_kwmeglgt_mc',
    },
  },
  bonus: {
    cid: 'c_pay_fkwj2a03',
    bid: {
      taskMV: 'b_pay_bvoah7ab_mv',
      taskMC: 'b_pay_bvoah7ab_mc',
      taskMore: 'b_pay_81fqppze_mc',
    },
  },
  bindcardPopup: {
    mv: 'b_pay_o9lzn2k3_mv',
    mc: 'b_pay_o9lzn2k3_mc',
  },
  // 2021.12 需求新增 https://km.sankuai.com/page/1221054371
  mainCardPromoBidMc: 'b_pay_lj9cxymf_mc',
  balanceDetailMv: 'b_pay_0j1cukjl_mv',
  balanceDetailMc: 'b_pay_0j1cukjl_mc',
  backIconMc: 'b_pay_xwygy7e1_mc',
  result: {
    withdraw: 'c_pay_e0poitbv',
    recharge: 'c_pay_rqy6i9h5',
  },
  // 账户合规弹窗
  guideInfo: {
    mv: 'b_pay_s6b66ep5_mv',
    mc: 'b_pay_s6b66ep5_mc',
    regulationMc: 'b_pay_lku6ovjl_mc',
  },
  riskModal: {
    mv: 'b_pay_264s3xll_mv',
  },

  questionListMv: 'b_pay_ccfj28am_mv',
  questionListMoreMc: 'b_txsva2ud',
  navRightButton: 'b_pay_zqbkqxwd_mc',
  navRightFunList: 'b_pay_f31t97yg_mc',
  // 余额公益捐赠，https://ocean.sankuai.com/config/#/demand/program/edit?flowId=42452&action=detail
  donate: {
    cid: 'c_pay_d7kn0bjg',
    bid: {
      donateModalMv: 'b_pay_k75won6y_mv',
      confirmDonateButtonMc: 'b_pay_wbsht7y1_mc',
      operateItemMv: 'b_pay_zynin5c1_mv',
      operateItemMc: 'b_pay_zynin5c1_mc',
      notSelfItemMv: 'b_pay_mu7o7jwc_mv',
      notSelfItemMc: 'b_pay_mu7o7jwc_mc',
    },
  },
  receiveBalance: {
    cid: 'c_pay_gxyhhwih',
    bid: {
      ruleMc: 'b_pay_hr38jyv6_mc',
    },
  },
  historyBalance: {
    cid: 'c_pay_fu12xcny',
  },
};

export const metricPoints = {
  index: 'balanceIndex', // 余额首页
};
